import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-33e2c8a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "under-construction"
};
const _hoisted_2 = {
  class: "app-container"
};
const _hoisted_3 = {
  class: "left-container"
};
const _hoisted_4 = {
  class: "video-info-container"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = {
  class: "video-info-detail"
};
const _hoisted_7 = {
  class: "video-info-detail-list"
};
const _hoisted_8 = {
  class: "view item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-bofangshu"
}, null, -1));
const _hoisted_10 = {
  class: "danmu item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-danmushu"
}, null, -1));
const _hoisted_12 = {
  class: "date item"
};
const _hoisted_13 = {
  key: 0,
  class: "video-cover-container",
  style: {
    "position": "relative"
  }
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "left-container-under-player"
};
const _hoisted_16 = {
  class: "right-container-inner"
};
const _hoisted_17 = {
  class: "multi-page-v1"
};
const _hoisted_18 = {
  class: "head-con"
};
const _hoisted_19 = {
  class: "head-left"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "视频选集", -1));
const _hoisted_21 = {
  class: "cur-page"
};
const _hoisted_22 = {
  class: "head-right"
};
const _hoisted_23 = {
  class: "next-button"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "txt"
}, "自动连播", -1));
const _hoisted_25 = {
  class: "cur-list"
};
const _hoisted_26 = {
  class: "list-box"
};
const _hoisted_27 = ["href", "title"];
const _hoisted_28 = {
  class: "clickitem"
};
const _hoisted_29 = {
  class: "link-content"
};
const _hoisted_30 = {
  class: "duration"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PlayerWrap = _resolveComponent("PlayerWrap");
  const _component_VideoProfile = _resolveComponent("VideoProfile");
  const _component_a_col = _resolveComponent("a-col");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_a_row = _resolveComponent("a-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_row, {
    gutter: 10,
    wrap: true
  }, {
    default: _withCtx(() => [_createVNode(_component_a_col, {
      flex: "auto",
      style: {
        "transition": "all .5s ease-out",
        "padding-left": "1px",
        "font-family": "'Harmony Font'"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h1", {
        title: $data.video.title,
        class: "video-title"
      }, _toDisplayString($data.video.title), 9, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_hoisted_9, _createTextVNode("  " + _toDisplayString($options.handleNum($data.view)) + "  ", 1)]), _createElementVNode("span", _hoisted_10, [_hoisted_11, _createTextVNode("  " + _toDisplayString($options.handleNum($data.danmu)) + "  ", 1)]), _createElementVNode("span", _hoisted_12, _toDisplayString($data.video.updateTime), 1)])])]), !$data.isFree ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("img", {
        src: $data.video.coverUrl,
        alt: "视频封面",
        class: "video-cover",
        style: _normalizeStyle({
          width: `${$data.imageSize.width}px`,
          height: `${$data.imageSize.height}px`
        })
      }, null, 12, _hoisted_14), _createElementVNode("div", {
        class: "cover-overlay",
        style: _normalizeStyle({
          position: 'absolute',
          top: '0',
          left: '0',
          width: `${$data.imageSize.width}px`,
          height: `${$data.imageSize.height}px`,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '20px',
          fontWeight: 'bold'
        })
      }, " 该视频为付费内容，请登录购买后观看 ", 4)])) : (_openBlock(), _createBlock(_component_PlayerWrap, {
        key: 1,
        videoUrl: $data.video.videoUrl,
        title: $data.video.title,
        duration: $data.video.duration,
        population: $data.population,
        jumpTimePoint: $data.jumpTimePoint,
        "onUpdate:jumpTimePoint": _cache[0] || (_cache[0] = $event => $data.jumpTimePoint = $event),
        autonext: $data.autonext,
        "onUpdate:autonext": _cache[1] || (_cache[1] = $event => $data.autonext = $event),
        onResize: $options.updatePlayerSize,
        onSendDm: $options.sendDanmu,
        onNext: $options.next,
        class: "player-container"
      }, null, 8, ["videoUrl", "title", "duration", "population", "jumpTimePoint", "autonext", "onResize", "onSendDm", "onNext"])), _createElementVNode("div", _hoisted_15, [_createVNode(_component_VideoProfile, {
        video: $data.video
      }, null, 8, ["video"])])])]),
      _: 1
    }), _createVNode(_component_a_col, {
      flex: "auto",
      style: {
        "transition": "all .5s ease-out",
        "padding-left": "1px",
        "font-family": "'Harmony Font'"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["right-container", {
          'visible-always': $data.isFree
        }])
      }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createTextVNode(), _createElementVNode("span", _hoisted_21, "(1/" + _toDisplayString($data.videoList.length) + ")", 1)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, [_hoisted_24, _createVNode(_component_el_switch, {
        modelValue: $data.autonext,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.autonext = $event)
      }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("ul", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.videoList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["", {
            'playing': item.id == $data.currentPlayingId
          }]),
          key: index
        }, [_createElementVNode("a", {
          href: `/video/detail/${item.id}`,
          title: item.title
        }, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", {
          class: _normalizeClass(["page-num", {
            'playing': item.id == $data.currentPlayingId
          }])
        }, "P" + _toDisplayString(index + 1), 3), _createTextVNode(), _createElementVNode("span", {
          class: _normalizeClass(["part", {
            'playing': item.id == $data.currentPlayingId
          }])
        }, _toDisplayString(item.title), 3)]), _createElementVNode("div", _hoisted_30, _toDisplayString($options.handleDuration(item.duration)), 1)])], 8, _hoisted_27)], 2);
      }), 128))])])])])], 2)]),
      _: 1
    })]),
    _: 1
  })])]);
}